import { useEffect } from 'react';
import { sendToNative } from '../../utils/NativeUtil';

const SCENE_WEBVIEW_BG = '#0D0E12';

export const useWebViewBackground = ({
  color = SCENE_WEBVIEW_BG,
  enabled = true
}: {
  color?: string;
  enabled?: boolean;
}) => {
  useEffect(() => {
    if (!enabled) return;

    sendToNative(
      JSON.stringify({
        type: 'setWebViewBackgroundColor',
        color: color
      })
    );
    return () => {
      sendToNative(
        JSON.stringify({
          type: 'setWebViewBackgroundColor',
          reset: true
        })
      );
    };
  }, [color, enabled]);
};
